
import React from 'react';
import { Sparkles } from 'lucide-react';
import ResearchCopilot from '../components/ResearchCopilot';

const ResearchAnalyticView: React.FC = () => {
  return (
    <div className="space-y-8 animate-in fade-in duration-300">
      <div>
          <ResearchCopilot />
      </div>
    </div>
  );
};

export default ResearchAnalyticView;
